var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.editorState === 'INIT')?_c('p',[_vm._v(_vm._s(_vm.$t('components.op.textViewer.states.init')))]):_vm._e(),_c('div',{attrs:{"id":_vm.editorId}}),(_vm.editorState === 'ERROR')?_c('p',[_vm._v(_vm._s(_vm.$t('components.op.textViewer.states.error'))+".")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }